import React from 'react';
import { TrendingUp, Users, Target, AlertTriangle } from 'lucide-react';

const insights = [
  {
    title: 'Market Trends',
    metrics: [
      { label: 'Growth Rate', value: '+15.3%', trend: 'up' },
      { label: 'Market Size', value: '$12.4B', trend: 'up' },
      { label: 'Active Contracts', value: '1,245', trend: 'up' },
    ],
    icon: TrendingUp,
    color: 'bg-blue-500',
  },
  {
    title: 'Competitive Analysis',
    metrics: [
      { label: 'Win Rate', value: '68%', trend: 'up' },
      { label: 'Avg. Contract Value', value: '$2.1M', trend: 'up' },
      { label: 'Market Share', value: '12%', trend: 'up' },
    ],
    icon: Target,
    color: 'bg-purple-500',
  },
  {
    title: 'Industry Insights',
    metrics: [
      { label: 'Top Performers', value: '45', trend: 'up' },
      { label: 'New Entrants', value: '23', trend: 'up' },
      { label: 'Industry Growth', value: '+8.2%', trend: 'up' },
    ],
    icon: Users,
    color: 'bg-green-500',
  },
  {
    title: 'Risk Analysis',
    metrics: [
      { label: 'Risk Score', value: '82/100', trend: 'up' },
      { label: 'Compliance Rate', value: '96%', trend: 'up' },
      { label: 'Active Alerts', value: '3', trend: 'down' },
    ],
    icon: AlertTriangle,
    color: 'bg-orange-500',
  },
];

export function MarketInsights() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">Market Insights</h2>
        <button className="text-sm font-medium text-purple-600 hover:text-purple-500">
          View Full Report
        </button>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        {insights.map((insight) => {
          const Icon = insight.icon;
          return (
            <div
              key={insight.title}
              className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm"
            >
              <div className="p-6">
                <div className="flex items-center space-x-3">
                  <div className={`rounded-lg ${insight.color} p-3`}>
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-medium text-gray-900">{insight.title}</h3>
                </div>

                <div className="mt-6 grid gap-4 sm:grid-cols-3">
                  {insight.metrics.map((metric) => (
                    <div key={metric.label}>
                      <p className="text-sm font-medium text-gray-500">{metric.label}</p>
                      <p className="mt-1 flex items-baseline">
                        <span className="text-2xl font-semibold text-gray-900">
                          {metric.value}
                        </span>
                        {metric.trend === 'up' ? (
                          <span className="ml-2 text-sm font-medium text-green-600">↑</span>
                        ) : (
                          <span className="ml-2 text-sm font-medium text-red-600">↓</span>
                        )}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}